"use client"

import { Text } from "@/elements"
import clsx from "clsx"
import { useSidebar, SecondaryBarContent } from "../Sidebar/useSidebar"
import { FragmentType, graphql, useFragment } from "@/gql"
import { BellIcon as BellIconOutline } from "@/icons/outline/BellIcon"
import { BellIcon as BellIconSolid } from "@/icons/solid/BellIcon"
import { NavItemWrapper } from "./NavItemWrapper"
import { NavItemBadge } from "./NavItemBadge"
import type { NovaSession } from "@/types"

const NotificationsNavItemFragment = graphql(`
  fragment NotificationsNavItem on User {
    id
    notificationCounts {
      unseen
    }
  }
`)

interface Props {
  forceHideLabel: boolean
  user: FragmentType<typeof NotificationsNavItemFragment> | null | undefined
  size: "default" | "lg"
  serverSession: NovaSession | null
}

export const NotificationsNavItem: React.FC<Props> = props => {
  const { forceHideLabel = false, size, serverSession } = props
  const { secondaryBar, openSecondaryBar, closeSecondaryBar } = useSidebar()
  const user = useFragment(NotificationsNavItemFragment, props.user)
  const isLarge = size === "lg"

  const showBadge = Boolean(user?.notificationCounts?.unseen && user.notificationCounts.unseen > 0)

  const isActive = secondaryBar.content === SecondaryBarContent.Notifications && secondaryBar.open

  const toggleSideBar = () => {
    if (secondaryBar.open) {
      closeSecondaryBar()
    } else {
      // ampli.notificationStreamOpen({
      //   account_type: serverSession?.account || "",
      // })
      openSecondaryBar({ content: SecondaryBarContent.Notifications })
    }
  }

  return (
    <div className="relative cursor-pointer" onClick={toggleSideBar}>
      <NavItemWrapper>
        <div className="relative">
          {showBadge && <NavItemBadge />}
          {isActive ? <BellIconSolid /> : <BellIconOutline className="text-fg-3" />}
        </div>
        <div className="absolute left-[44px] transition-opacity duration-200 ease-in-out md:opacity-0 lg:opacity-100">
          <Text
            variant={isLarge ? "h4" : "body1"}
            className={clsx("md:hidden lg:flex", forceHideLabel && "!hidden", isActive ? "text-fg-1" : "text-fg-3")}>
            Notifications
          </Text>
        </div>
      </NavItemWrapper>
    </div>
  )
}
